import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';
import './Contact.css';

const PRODUCTS = [
  'MS Chat – Chatbot + CRM',
  'Email Campaign',
  'Email Verifier',
  'SEO & AEO',
  'Web Development',
  'iOS & Android App',
  'Data Services',
  'Other'
];

export default function Contact() {
  useEffect(() => {
    document.title = 'Contact Us | MS Discoveries';
  }, []);

  const [form, setForm]     = useState({ name:'', email:'', phone:'', business:'', product:'', message:'' });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState(''); // '' | 'sending' | 'success' | 'error'

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = 'Name required';
    if (!form.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = 'Valid email required';
    if (!form.message.trim()) e.message = 'Message required';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setStatus('sending');
    try {
      await api.submitContact(form);
      setStatus('success');
      setForm({ name:'', email:'', phone:'', business:'', product:'', message:'' });
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="contact-hero__glow" />
        <div className="container">
          <div className="section-tag">Get In Touch</div>
          <h1 className="section-title">Let's <span className="highlight">Talk</span></h1>
          <p className="section-desc">Have a question or ready to get started? Fill out the form and we'll get back to you within 24 hours.</p>
        </div>
      </section>

      <section className="contact-body">
        <div className="container contact-grid">
          {/* Info */}
          <div className="contact-info">
            <h3>Contact Information</h3>
            <div className="contact-info__items">
              <div className="contact-info__item">
                <div className="contact-info__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                </div>
                <div>
                  <strong>Email</strong>
                  <a href="mailto:hola@msdiscoveries.com">hola@msdiscoveries.com</a>
                </div>
              </div>
              <div className="contact-info__item">
                <div className="contact-info__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 .99h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/></svg>
                </div>
                <div>
                  <strong>Phone</strong>
                  <a href="tel:+919443724724">+91 9443724724</a>
                </div>
              </div>
              <div className="contact-info__item">
                <div className="contact-info__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                </div>
                <div>
                  <strong>Response Time</strong>
                  <span>Within 24 hours</span>
                </div>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="contact-form-wrap">
            <h3>Send Us a Message</h3>
            {status === 'success' ? (
              <div className="contact-success">
                <div className="contact-success__icon">✓</div>
                <h4>Message Sent!</h4>
                <p>Thank you! We'll get back to you within 24 hours.</p>
                <button className="btn-primary" onClick={() => setStatus('')}><span>Send Another</span></button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="contact-form">
                {status === 'error' && (
                  <div style={{background:'rgba(255,68,68,0.1)',border:'1px solid rgba(255,68,68,0.3)',borderRadius:'8px',padding:'12px 16px',color:'#ff6b6b',fontSize:'14px',marginBottom:'16px'}}>
                    Something went wrong. Please try again or email us directly.
                  </div>
                )}
                <div className="form-row">
                  <div className="form-field">
                    <label>FULL NAME *</label>
                    <input type="text" value={form.name} onChange={e => set('name', e.target.value)} placeholder="Your name" className={errors.name ? 'error' : ''} />
                    {errors.name && <span className="form-error">{errors.name}</span>}
                  </div>
                  <div className="form-field">
                    <label>EMAIL ADDRESS *</label>
                    <input type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="your@email.com" className={errors.email ? 'error' : ''} />
                    {errors.email && <span className="form-error">{errors.email}</span>}
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field">
                    <label>PHONE NUMBER</label>
                    <input type="tel" value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="+91 XXXXX XXXXX" />
                  </div>
                  <div className="form-field">
                    <label>BUSINESS NAME</label>
                    <input type="text" value={form.business} onChange={e => set('business', e.target.value)} placeholder="Your company" />
                  </div>
                </div>
                <div className="form-field">
                  <label>INTERESTED IN</label>
                  <select value={form.product} onChange={e => set('product', e.target.value)}>
                    <option value="">Select a product or service</option>
                    {PRODUCTS.map(p => <option key={p} value={p}>{p}</option>)}
                  </select>
                </div>
                <div className="form-field">
                  <label>MESSAGE *</label>
                  <textarea value={form.message} onChange={e => set('message', e.target.value)} placeholder="Tell us about your business and how we can help..." rows={6} className={errors.message ? 'error' : ''} />
                  {errors.message && <span className="form-error">{errors.message}</span>}
                </div>
                <button type="submit" className="btn-primary contact-submit" disabled={status === 'sending'}>
                  <span>{status === 'sending' ? 'Sending...' : 'Send Message'}</span>
                  {status !== 'sending' && (
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
                      <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
                    </svg>
                  )}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}